import React, { memo } from 'react';
import styled from 'styled-components';

const CellContent = styled.div`
  overflow: auto;
  height: 32px;
  display: flex;
  align-items: center;

  > span {
    width: 100%;
    margin: auto 0;
  }
`;

const _Cell: React.FC<{ className?: string; children: React.ReactNode }> = ({
  children,
  className,
}) => (
  <td className={className}>
    <CellContent>
      <span>{children}</span>
    </CellContent>
  </td>
);

export const Cell = memo(_Cell);
